export const SET_APPLICATION_MENU = 'SET_APPLICATION_MENU'
export const SET_CURRENT_PANEL = 'SET_CURRENT_PANEL'
export const MOVE_PANEL_TO_DOCK = 'MOVE_PANEL_TO_DOCK'
export const MOVE_PANEL_TO_PANEL_GROUP = 'MOVE_PANEL_TO_PANEL_GROUP'
export const MOVE_PANEL_NEXT_TO_PANEL_GROUP = 'MOVE_PANEL_NEXT_TO_PANEL_GROUP'
export const MOVE_PANEL_GROUP_TO_DOCK = 'MOVE_PANEL_GROUP_TO_DOCK'
export const SET_DOCK_SIZE = 'SET_DOCK_SIZE'
export const SET_TREE_SIZE = 'SET_TREE_SIZE'
export const SET_SETTING = 'SET_SETTING'
export const RESET_PANELS = 'RESET_PANELS'
export const SET_PROMPT = 'SET_PROMPT'
export const CLOSE_PROMPT = 'CLOSE_PROMPT'
export const OPEN_POPOUT = 'OPEN_POPOUT'
export const CLOSE_POPOUT = 'CLOSE_POPOUT'



// WEBPACK FOOTER //
// ./app/constants/interface.js